import React from 'react';
import { Box } from '@mui/system';
import { makeStyles } from '@mui/styles';
import Banner from '../../atoms/Banner/Banner';
import Typography from '../../atoms/Typography/Typography';
import Plancard from '../../atoms/Plancard';

const useStyles = makeStyles({
  root: {},
  topBox: {
    display: 'flex',
    flexDirection: 'column',
    '@media only screen and (max-width: 768px)': {
      marginTop: '100px',
    },
  },
  commonBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'end',
    marginBottom: '100px',
    '@media only screen and (max-width: 768px)': {
      marginBottom: '0px',
    },
  },
  commonBackBox: {
    backgroundColor: '#f4f6f9',
    width: '80%',
    height: '20vw',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    paddingLeft: '40px',
    paddingBottom: '40px',
  },
  commonText: {
    fontFamily: 'Pretendard',
    fontSize: '50px',
    fontWeight: 600,
    letterSpacing: '-0.5px',
    textAlign: 'left',
    color: '#0b508a',
    '@media only screen and (max-width: 768px)': {
      fontSize: '30px',
    },
  },
  commonImgBox: {
    width: '80%',
    marginTop: '70px',
    '@media only screen and (max-width: 425px)': {
      width: '90%',
    },
  },
  commonImgLine1: {
    display: 'flex',
    marginLeft: '30vw',
    justifyContent: 'flex-start',
  },
  commonImgLine2: {
    display: 'flex',

    marginLeft: '30vw',
    '@media only screen and (max-width: 768px)': {
      paddingLeft: '0vw',
      boxSizing: 'border-box',
    },
  },
  commonOneImgBox: {
    // width: '100px',
    '@media only screen and (max-width: 768px)': {
      width: '90px',
      marginBottom: '60px',
    },
  },
  commonOneImgImg: {
    marginBottom: '18px',
    width: '125px',
    '@media only screen and (max-width: 768px)': {
      width: '60px',
    },
  },
  commonOneImgText: {
    width: '16vw',
    fontSize: '16px',
    '@media only screen and (max-width: 768px)': {
      width: '80px',
      fontSize: '12px',
    },
  },
  //
  middleBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  middleTitleBox: {
    width: '100%',
    backgroundColor: 'black',
    textAlign: 'center',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  middleTitleText: {
    textDecoration: 'underline',
    fontWeight: 600,
    fontSize: '24px',
    lineHeight: 1.25,
    color: '#f4f4f4',
    '@media only screen and (max-width: 768px)': {
      fontSize: '16px',
    },
  },

  planCardBox: {
    width: '70%',
    marginTop: '88px',
    display: 'flex',
    justifyContent: 'space-between',
    '@media only screen and (max-width: 768px)': {
      flexDirection: 'column',
    },
  },

  //
  topBox2: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginBottom: '105px',
    backgroundColor: '#f4f6f9',

    '@media only screen and (max-width: 768px)': {
      flexDirection: 'column',
    },
  },
  graduBox: {
    marginRight: '100px',
    display: 'flex',
    flexDirection: 'column',

    '@media only screen and (max-width: 768px)': {
      marginRight: '0px',
      marginLeft: '10%',
    },
  },
  graduText: {
    marginTop: '40px',
    fontFamily: 'Pretendard',
    fontSize: '50px',
    fontWeight: 600,
    letterSpacing: '-0.5px',
    textAlign: 'center',
    color: '#0b508a',
    marginBottom: '70px',
    '@media only screen and (max-width: 768px)': {
      fontSize: '30px',
      textAlign: 'left',
    },
  },
  graduImgLine1: {
    display: 'flex',
    '@media only screen and (max-width: 768px)': {},
  },
  authBox: {
    display: 'flex',
    flexDirection: 'column',

    '@media only screen and (max-width: 768px)': {
      marginLeft: '10%',
    },
  },
  authText: {
    marginTop: '40px',
    fontFamily: 'Pretendard',
    fontSize: '50px',
    fontWeight: 600,
    letterSpacing: '-0.5px',
    textAlign: 'left',
    color: '#0b508a',
    marginBottom: '70px',

    '@media only screen and (max-width: 768px)': {
      fontSize: '30px',
    },
  },
  authImgLine1: {
    display: 'flex',
  },
  //
  bottomBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  systemBox: {
    display: 'flex',

    width: '80%',
    '@media only screen and (max-width: 768px)': {
      flexDirection: 'column',
    },
  },
  mapBox: {
    width: '80%',
    marginBottom: '50px',
    '@media only screen and (max-width: 768px)': {
      width: '100%',
      marginBottom: '32px',
    },
  },
  systemTitle: {
    fontFamily: 'Pretendard',
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: 1.2,
    letterSpacing: '-0.2px',
    textAlign: 'left',
    color: '#191919',
  },
  systemText: {
    fontFamily: 'Pretendard',
    fontSize: '16px',
    lineHeight: 1.25,
    letterSpacing: '-0.16px',
    textAlign: 'left',
    color: '#191919',
    marginTop: '20px',
  },
  bottomTitleBox: {
    width: '100%',
    backgroundColor: 'black',
    textAlign: 'center',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '105px',
    marginTop: '105px',
  },
  bottomTitleText: {
    textDecoration: 'underline',
    fontWeight: 600,
    fontSize: '24px',
    lineHeight: 1.25,
    color: '#f4f4f4',
    '@media only screen and (max-width: 1280px)': {
      fontSize: '16px',
    },
  },
  imgBox: {
    width: '20%',
  },
  img1: {
    width: '328px',
    '@media only screen and (max-width: 1280px)': {
      display: 'none',
    },
  },
  img2: {
    width: '328px',
    marginLeft: '-164px',
    marginTop: '-200px',
    '@media only screen and (max-width: 1280px)': {
      display: 'none',
    },
  },
  planCard: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    '@media only screen and (max-width: 768px)': {
      marginBottom: '40px',
    },
  },
});

export default function TraineeBenefitsPage() {
  const classes = useStyles();

  const bannerData = {
    imgSrc: '/images/image/message title@2x.png',
    imgSrcM: '/images/image/messagem title@2x.png',
    title: 'Trainee Benefits',
    text1: 'Best of the Best supports the future of trainees.',
  };

  const planCardData = [
    {
      ImageSrc: '/images/icon/card/flaticon13.png',

      month: 'employment',

      title: '',
      text: [
        {
          line: 'Support for exchanges through ecruiting expert networks, job fairs, etc.',
        },
      ],
    },
    {
      ImageSrc: '/images/icon/card/flaticon14.png',
      month: 'founded',

      title: '',
      text: [
        {
          line: 'Prepare additional realistic support measures to enable technology-oriented start-ups such as lean start-ups and incubators (free consulting support projects, etc.)',
        },
      ],
    },
    {
      ImageSrc: '/images/icon/card/flaticon15.png',

      month: 'further education',

      title: '',

      text: [
        {
          line: 'Direct linkage plan through MOU with universities',
        },
      ],
    },
  ];

  const systemData = [
    {
      title: 'R&D support',
      text: 'Discovery of excellent research manpower and support for career advancement in research fields',
    },
    {
      title: 'Competition team',
      text: 'Acquire the latest global technology trends through participation in international information security competitions',
    },
    {
      title: 'Vulnerability Analysis Team',
      text: 'Employment/startup support through joint project promotion with industry',
    },
    {
      title: 'Security Consulting Team',
      text: 'Free vulnerability analysis for the vulnerable among small businesses',
    },
    {
      title: 'Regular exchange meeting',
      text: 'Formation of human networking such as sharing and communication of various security information',
    },
    {
      title: 'Talent donation',
      text: 'Dissemination of information security technology through middle school, high school, university, and club visiting education and seminars',
    },
    {
      title: 'Operation-based system',
      text: 'Provision of operational basis for managing graduates and sharing related technical information',
    },
  ];

  return (
    <Box className={classes.root}>
      <Banner bannerData={bannerData} />
      <Box className={classes.topBox}>
        <Box className={classes.commonBox}>
          <Box className={classes.commonBackBox}>
            <Typography className={classes.commonText}>Common</Typography>
            <Typography className={classes.commonText}>support matters</Typography>
          </Box>
          <Box className={classes.commonImgBox}>
            <Box className={classes.commonImgLine1}>
              <Box className={classes.commonOneImgBox}>
                <img className={classes.commonOneImgImg} src='/images/icon/8_employee.png' alt='test' />
                <Typography className={classes.commonOneImgText}>Learning space dedicated to trainees</Typography>
              </Box>
              <Box className={classes.commonOneImgBox}>
                <img className={classes.commonOneImgImg} src='/images/icon/38_site_in_laptop.png' alt='test' />
                <Typography className={classes.commonOneImgText}>Latest IT equipment reference book</Typography>
              </Box>
            </Box>

            <Box className={classes.commonImgLine2}>
              <Box>
                <Box className={classes.commonOneImgBox}>
                  <img className={classes.commonOneImgImg} src='/images/icon/35_money_box.png' alt='test' />
                  <Typography className={classes.commonOneImgText}>Transportation cost support Tuition free</Typography>
                </Box>
                <Box className={classes.commonOneImgBox}>
                  <img className={classes.commonOneImgImg} src='/images/icon/29_form.png' alt='test' />
                  <Typography className={classes.commonOneImgText}>Project activity support</Typography>
                </Box>
              </Box>
              <Box>
                <Box className={classes.commonOneImgBox}>
                  <img className={classes.commonOneImgImg} src='/images/icon/31_suitcase.png' alt='test' />
                  <Typography className={classes.commonOneImgText}>Dormitory support for local trainees</Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box className={classes.topBox2}>
          <Box className={classes.graduBox}>
            <Typography className={classes.graduText}>Graduate Privileges</Typography>
            <Box className={classes.graduImgLine1}>
              <Box className={classes.commonOneImgBox}>
                <img className={classes.commonOneImgImg} src='/images/icon/10_dialog.png' alt='test' />
                <Typography className={classes.commonOneImgText}>Post-Security Research Group</Typography>
              </Box>
              <Box className={classes.commonOneImgBox}>
                <img className={classes.commonOneImgImg} src='/images/icon/7_distribution_of_tasks.png' alt='test' />
                <Typography className={classes.commonOneImgText}>Customized career link</Typography>
              </Box>
            </Box>
          </Box>
          <Box className={classes.authBox}>
            <Typography className={classes.authText}>Authenticator Privileges</Typography>
            <Box className={classes.authImgLine1}>
              <Box className={classes.commonOneImgBox}>
                <img className={classes.commonOneImgImg} src='/images/icon/28_documentation.png' alt='test' />
                <Typography className={classes.commonOneImgText}>Ministry of Science and Technology Information and Communication certification KITRI Certificate</Typography>
              </Box>
              <Box className={classes.commonOneImgBox}>
                <img className={classes.commonOneImgImg} src='/images/icon/27_tie.png' alt='test' />
                <Typography className={classes.commonOneImgText} style={{ fontWeight: 'bold' }}>
                  Best 10{' '}
                </Typography>
                <Typography className={classes.commonOneImgText} style={{ marginBottom: '12px' }}>
                  - Overseas training, etc.
                </Typography>
                <Typography className={classes.commonOneImgText} style={{ fontWeight: 'bold' }}>
                  Grand Prix{' '}
                </Typography>
                <Typography className={classes.commonOneImgText}>- Support for start-up and technology commercialization</Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className={classes.middleBox}>
        <Box className={classes.middleTitleBox}>
          <Typography className={classes.middleTitleText}>Vigilance</Typography>
        </Box>
        <Box className={classes.planCardBox}>
          {planCardData.map((pData, i) => {
            return (
              <Box className={classes.planCard} key={i}>
                <Plancard data={pData} />
              </Box>
            );
          })}
        </Box>
      </Box>
      <Box className={classes.bottomBox}>
        <Box className={classes.bottomTitleBox}>
          <Typography className={classes.bottomTitleText}>Post-management system for graduates</Typography>
        </Box>
        <Box className={classes.systemBox}>
          <Box>
            {systemData.map((sData, i) => {
              return (
                <Box className={classes.mapBox} key={i}>
                  <Typography className={classes.systemTitle}>{sData.title}</Typography>
                  <Typography className={classes.systemText}>{sData.text}</Typography>
                </Box>
              );
            })}
          </Box>
          <Box className={classes.imgBox}>
            <img className={classes.img1} src='/images/image/priscilla-du-preez-NjirplnVra8-unsplash@2x.png' alt='test' />
            <img className={classes.img2} src='/images/image/campaign-creators-e6n7uoEnYbA-unsplash@2x.png' alt='test' />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
